<template>
  <div class="map-mode-switcher glass-panel" :class="{ 'is-mobile': isMobile }">
    <div 
      v-for="option in options" 
      :key="option.value"
      class="mode-option"
      :class="{ active: modelValue === option.value }"
      @click="$emit('update:modelValue', option.value)"
    >
      <span class="mode-icon">{{ option.icon }}</span>
      <span class="mode-label">{{ option.label }}</span>
    </div>
    <div class="active-indicator" :style="indicatorStyle"></div>
  </div>
</template>

<script>
export default {
  name: 'MapModeSwitcher',
  props: {
    modelValue: {
      type: String,
      default: 'outline'
    },
    isMobile: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      options: [
        { label: '二维', value: 'outline', icon: '平面' },
        { label: '三维', value: 'outline3d', icon: '视投' },
        { label: '卫星', value: 'satellite', icon: '遥感' }
      ]
    }
  },
  computed: {
    activeIndex() {
      return this.options.findIndex(opt => opt.value === this.modelValue)
    },
    indicatorStyle() {
      const step = 100 / this.options.length
      return {
        width: `${step}%`,
        left: `${this.activeIndex * step}%`
      }
    }
  }
}
</script>

<style scoped>
.map-mode-switcher {
  position: relative;
  display: flex;
  background: var(--dash-switcher-bg);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border: 1px solid var(--dash-switcher-border);
  border-radius: 99px;
  padding: 0;
  gap: 0;
  overflow: hidden;
  pointer-events: auto;
  box-shadow: var(--dash-switcher-shadow);
  user-select: none;
  width: fit-content;
}

.mode-option {
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 10px 20px;
  min-width: 80px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border-radius: 99px;
}

.mode-icon {
  font-size: 0.7rem;
  font-weight: 500;
  color: var(--dash-mode-text);
  margin-bottom: 3px;
  letter-spacing: 1px;
}

.mode-label {
  font-size: 1rem;
  font-weight: 600;
  color: var(--dash-mode-text);
  letter-spacing: 2px;
}

.mode-option:hover .mode-icon,
.mode-option:hover .mode-label {
  color: var(--dash-mode-text-hover);
}

.mode-option.active .mode-icon {
  color: var(--dash-mode-text-active);
}

.mode-option.active .mode-label {
  color: var(--dash-mode-text-active);
  font-weight: 700;
}

.active-indicator {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  background: var(--dash-switcher-indicator);
  border-left: 1px solid var(--dash-switcher-border);
  border-right: 1px solid var(--dash-switcher-border);
  transition: all 0.35s cubic-bezier(0.25, 1, 0.5, 1);
  box-shadow: inset 0 0 15px var(--dash-accent-muted);
}

/* Mobile adjustments */
.is-mobile {
  padding: 2px !important;
  gap: 2px !important;
}

.is-mobile .mode-option {
  padding: 6px 12px;
  min-width: 50px;
}

.is-mobile .mode-label {
  font-size: 0.85rem;
}

.is-mobile .mode-icon {
  font-size: 0.65rem;
}
</style>
